module.exports = __webpack_public_path__ + "media/site_templates/www.tilingquotes.com.au/images/our_services_2-7ec5212692afe650f8b9fdaa76ae60ae.jpg";